import i18next from 'i18next';

import { getProductType } from '@commons/utils/product';
import utilsXLS from '@commons/utils/makeXLS';

const getColumnsSettings = ({ hasSimpleModifierManagement }) => {
  const columns = [
    {
      propertyKey: 'name',
      name: i18next.t('GENERAL.NAME'),
    },
    {
      propertyKey: 'cashierName',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.CASHIER'),
    },
    {
      propertyKey: 'created_at',
      name: i18next.t('BACKOFFICE.CHECKS.EXPORT_MODAL_LABEL_DATE'),
    },
    {
      propertyKey: 'tags',
      name: i18next.t('BACKOFFICE.CHECKS.EXPORT_MODAL_LABEL_TAGS'),
    },
    {
      propertyKey: 'updated_at',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.LAST_MODIFICATION'),
    },
    {
      propertyKey: 'sku',
      name: i18next.t('GENERAL.SKU'),
    },
    {
      type: 'currency',
      propertyKey: 'price_with_taxes',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.ASSOCIATION_MODAL_LIST_COLUMN_PRICE'),
    },
    {
      propertyKey: 'vat_rate',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.ASSOCIATION_MODAL_LIST_COLUMN_VAT_RATE'),
    },
    {
      propertyKey: 'mapped',
      name: i18next.t('GENERAL.LINKED'),
    },
    {
      propertyKey: 'product_name',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.ASSOCIATED_PRODUCT_NAME'),
    },
    {
      propertyKey: 'product_category_name',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.ASSOCIATED_PRODUCT_CATEGORY'),
    },
    {
      propertyKey: 'associated_sku',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.ASSOCIATED_SKU'),
    },
    {
      propertyKey: 'active',
      name: i18next.t('GENERAL.ACTIVE'),
    },
    {
      propertyKey: 'hidden',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.EXCLUDED'),
    },
    {
      propertyKey: 'cashier_connection',
      name: i18next.t('GENERAL.CASHIER_CONNEXION'),
    },
    {
      propertyKey: 'sold_at',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.LAST_SALE'),
    },
  ];

  if (hasSimpleModifierManagement) {
    columns.splice(1, 0, {
      propertyKey: 'parent_cashier_product_name',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.PARENT_CASHIER_PRODUCT_NAME'),
    });

    columns.splice(6, 0, {
      propertyKey: 'productType',
      name: i18next.t('ADMIN.CASHIER_PRODUCTS.PRODUCT_TYPE'),
    });
  }

  return columns;
};

export const exportCashierProducts = (props) => {
  const { selectedCashierProducts, currency, hasSimpleModifierManagement } = props;

  const columnsSettings = getColumnsSettings({ hasSimpleModifierManagement });

  const formattedCashierProducts = selectedCashierProducts.map((cashierProduct) => ({
    ...cashierProduct,
    ...(cashierProduct.tags ? { tags: cashierProduct.tags.join(', ') } : {}),
    mapped: !!cashierProduct.product_cashier_product_mapping_id
      ? i18next.t('GENERAL.YES')
      : i18next.t('GENERAL.NO'),
    active: !!cashierProduct.active ? i18next.t('GENERAL.YES') : i18next.t('GENERAL.NO'),
    hidden: !!cashierProduct.hidden ? i18next.t('GENERAL.YES') : i18next.t('GENERAL.NO'),
    productType: getProductType(cashierProduct),
  }));

  const sheet = utilsXLS.generateDefaultSheet(
    i18next.t('ADMIN.CASHIER_PRODUCTS.EXPORT_SHEET_NAME'),
    columnsSettings,
    formattedCashierProducts,
    currency,
  );

  utilsXLS.makeXLS(i18next.t('ADMIN.CASHIER_PRODUCTS.EXPORT_FILE_NAME'), [sheet]);
};
